import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        registrationForm: {
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            student_number: '',
            insurance_number: '',

            parent_first_name: '',
            parent_last_name: '',
            parent_email: '',
            parent_phone: '',

            address_street: '',
            address_city: '',
            address_zipcode: '',
            address_number: '',
            address_number_addition: '',

            brand: '',
            model: '',
            serial_number: '',
            access_code: '',
            description: '',

            delivery_method: ''
        }
    },

    mutations: {
        SET_REGISTRATION_FIELD: (state, payload) => {
            Vue.set(state.registrationForm, payload.property, payload.value);
        }
    }
});
